// src/components/facility/panels/EventsPanel.js
import React from 'react';

const SEVERITY_COLOR = {
  critical: 'var(--red)',
  high:     'var(--red)',
  medium:   'var(--yellow)',
  low:      'var(--text-muted)',
};

function EventRow({ evt, state, dispatch }) {
  const hasMaintenance = state.workers.some(
    w => w.type === 'maintenance' && w.assignedRoomId === evt.roomId
  );

  function resolveButton() {
    if (evt.type === 'buyout_offer') {
      return (
        <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
          <button
            className="btn btn-primary btn-sm"
            style={{ background: '#d4a017', borderColor: '#d4a017', color: '#0a0800', fontWeight: 800 }}
            onClick={() => dispatch({ type: 'ACCEPT_BUYOUT' })}
          >💰 Accept $1M</button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => dispatch({ type: 'REJECT_BUYOUT' })}
          >Decline</button>
        </div>
      );
    }
    if (evt.type === 'compliance_investigation') {
      return (
        <button
          className="btn btn-danger btn-sm"
          style={{ marginTop: 8 }}
          onClick={() => dispatch({ type: 'RESOLVE_EVENT', payload: { eventId: evt.id } })}
        >⚖️ Cooperate</button>
      );
    }
    if (evt.type === 'room_inspection') {
      return (
        <button
          className="btn btn-warn btn-sm"
          style={{ marginTop: 8 }}
          onClick={() => dispatch({ type: 'RESOLVE_EVENT', payload: { eventId: evt.id } })}
        >🔍 Conduct Inspection</button>
      );
    }
    if (evt.type === 'equipment_failure') {
      const partsCost = evt.issue?.requiresParts ? (evt.issue.partsCost || 0) : 0;
      const laborCost = hasMaintenance ? 0 : 100;
      const total = partsCost + laborCost;
      return (
        <button
          className="btn btn-warn btn-sm"
          style={{ marginTop: 8 }}
          disabled={state.cash < total}
          onClick={() => dispatch({ type: 'RESOLVE_EVENT', payload: { eventId: evt.id } })}
        >
          {hasMaintenance
            ? `🔧 Dispatch Maintenance${partsCost > 0 ? ` ($${partsCost})` : ' (Free)'}`
            : `🔧 Repair ($${total})`}
        </button>
      );
    }
    if (evt.resolutionCost > 0) {
      const label =
        evt.type === 'power_outage'   ? `⚡ Restore Power $${evt.resolutionCost}` :
        evt.type === 'pest_outbreak'  ? `🐛 Treat Pests $${evt.resolutionCost}` :
        evt.type === 'powdery_mildew' ? `🍄 Spray Fungicide $${evt.resolutionCost}` :
        `Fix $${evt.resolutionCost}`;
      return (
        <button
          className="btn btn-warn btn-sm"
          style={{ marginTop: 8 }}
          disabled={state.cash < evt.resolutionCost}
          onClick={() => dispatch({ type: 'RESOLVE_EVENT', payload: { eventId: evt.id } })}
        >{label}</button>
      );
    }
    return null;
  }

  const sevColor = SEVERITY_COLOR[evt.severity] || 'var(--text-muted)';

  return (
    <div style={{
      background: '#1a1810',
      border: `1px solid ${evt.severity === 'critical' || evt.severity === 'high' ? '#3a1a10' : '#2a2618'}`,
      borderLeft: `3px solid ${sevColor}`,
      borderRadius: 6,
      padding: '10px 12px',
      marginBottom: 8,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 18 }}>{evt.icon || '⚠'}</span>
          <div>
            <div style={{ fontWeight: 600, fontSize: 13 }}>{evt.label}</div>
            {evt.roomName && <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{evt.roomName}</div>}
          </div>
        </div>
        <span style={{ fontSize: 10, fontWeight: 700, color: sevColor, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          {evt.severity}
        </span>
      </div>
      {evt.description && (
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6, lineHeight: 1.5 }}>
          {evt.description}
        </div>
      )}
      {resolveButton()}
    </div>
  );
}

export function EventsPanel({ state, dispatch }) {
  const events = (state.activeEvents || []).filter(e => !e.resolved);

  if (events.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '24px 0', color: 'var(--text-dim)', fontSize: 13 }}>
        ✓ No active events. Facility running clean.
      </div>
    );
  }

  return (
    <div>
      {events.map(evt => (
        <EventRow key={evt.id} evt={evt} state={state} dispatch={dispatch} />
      ))}
    </div>
  );
}
